const diagnostic = {
  diagnostRequestSentSuccess: false,
};

export default diagnostic;
